import React, { useEffect, useState } from "react";
import TextInput from "../TextInput";
import { datePattern } from "./dateUtils";
const DateInput = React.forwardRef((props, ref) => {
  let {
    id,
    label,
    placeholder,
    inputProps,
    InputProps,
    name,
    sep = "/",
    value = "",
    disabled = false,
    pattern = `DD${sep}MM${sep}YYYY`,
    allowFuture = true,
    allowPast = true,
    startYear = "1900",
    endYear = "9999",
    size,
    required,
    onChange = () => {},
    onFocus = () => {},
    onBlur = () => {},
    isFutureDate = () => {},
    isPastDate = () => {},
    error,
    autoFocus,
    maxDate = "",
    minDate = "",
  } = props;
  const [date, setDate] = useState("");
  const [validDate, setValidDate] = useState(true);
  const changeHandler = (e, value) => {
    let updatedDate = "";
    let filteredDate = datePattern(
      value,
      pattern,
      sep,
      startYear,
      endYear,
      allowFuture,
      allowPast,
      maxDate,
      minDate
    );
    if (filteredDate) {
      updatedDate = filteredDate.currVal.join(sep);
    }
    if (filteredDate?.isFutureDate) {
      isFutureDate();
    }
    if (filteredDate?.isPastDate) {
      isPastDate();
    }
    // let myDate = moment(updatedDate, pattern).format("x");
    // if (
    //   (!allowFuture && updatedDate.length === 10 && myDate > endDate) ||
    //   (!allowPast && date.length === 10 && myDate < endDate)
    // ) {
    //   updatedDate = updatedDate.slice(0, -1);
    // }
    setDate(updatedDate);
    onChange(e, updatedDate, {
      date: filteredDate.date,
      month: filteredDate.month,
      year: filteredDate.year,
    });
  };
  useEffect(() => {
    setDate(value);
  }, [value]);
  useEffect(() => {
    if (date && date.length > 0 && date.length < pattern.length) {
      setValidDate(false);
    } else {
      setValidDate(true);
    }
  }, [date, pattern]);
  return (
    <TextInput
      ref={ref}
      disabled={disabled}
      size={size}
      name={name}
      label={label}
      isFutureDate={isFutureDate}
      isPastDate={isPastDate}
      InputProps={InputProps}
      onChange={(e) => changeHandler(e, e.target.value)}
      onFocus={onFocus}
      onKeyDown={(e) => {
        const key = e.key;
        if (key === "Backspace") {
          if (document.getSelection().toString() === e.target.value) {
            return;
          } else {
            e.preventDefault();
          }
          let updatedDate = null;
          if (date?.charAt(date.length - 1) === sep) {
            updatedDate = date.slice(0, -2);
          } else {
            updatedDate = date.slice(0, -1);
          }
          changeHandler(e, updatedDate);
          // setDate(updatedDate);
          // onChange(e, updatedDate);
        }
      }}
      onBlur={(e) => {
        onBlur(e, date, validDate);
      }}
      value={date}
      id={id}
      placeholder={placeholder}
      inputProps={inputProps}
      required={required}
      error={error}
      autoFocus={autoFocus}
    />
  );
});
export default DateInput;
